var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-col',{staticClass:"teaser-head",attrs:{"cols":"12"}},[_c('cg-event-type',{staticClass:"event-type",attrs:{"event":_vm.event}}),_c('cg-event-teaser-date',{staticClass:"event-date",attrs:{"event":_vm.event}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }